<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="fill-height">
            <form-tabs v-model="tab" v-slot="{ prev, next }">
                <!-- 기본 입력 -->
                <tabs-basic
                    v-bind="{
                        value: form,
                        loading,
                    }"
                    v-on="{
                        exit,
                        next,
                        setLoading,
                        input: setForm,
                    }"
                />
                <!-- 필드 입력 -->
                <tabs-pages
                    v-bind="{
                        value: form,
                        tab,
                        shows,
                        loading,
                    }"
                    v-on="{
                        prev,
                        save,
                        setLoading,
                        input: setForm,
                    }"
                />
            </form-tabs>
        </v-layout>
        <client-loader v-bind="{ loading }" />
    </bottom-sheet>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import api from "@/api";
import { EMPLOYMENT_FIELD_TYPES, initEmploymentForm } from "@/assets/variables";
import { TABS } from "./form/lib";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ClientLoader from "@/components/client/dumb/client-loader.vue";
import FormTabs from "./form/form-tabs.vue";
import TabsBasic from "./form/tabs/tabs-basic.vue";
import TabsPages from "./form/tabs/tabs-pages.vue";

export default {
    components: {
        BottomSheet,
        ClientLoader,
        FormTabs,
        TabsBasic,
        TabsPages,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        tab: TABS.BASIC.value,
        shows: false,
    }),
    computed: {
        ...mapState("employment/form", ["form", "loading"]),
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "근로계약서 ";
            title += this.isCreate ? "생성하기" : "수정하기";
            return title;
        },
    },
    mounted() {
        if (this.shows) this.init();
    },
    watch: {
        shows() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
    },
    methods: {
        ...mapMutations("employment/form", ["setForm", "setLoading"]),

        async init() {
            this.tab = this.isCreate ? TABS.BASIC.value : TABS.PAGES.value;

            if (this.isCreate) this.setForm(initEmploymentForm());
            else {
                if (this.loading) return;
                else this.setLoading(true);
                try {
                    let { form } = await api.v1.company.employment.forms.get({ _id: this.value?._id });
                    this.setForm(initEmploymentForm(form));
                } finally {
                    this.setLoading(false);
                }
            }
        },

        async save() {
            if (!this.validates()) return;
            if (this.loading) return;
            else this.setLoading(true);

            try {
                let { _file, file, _pages, pages, fields, ...form } = this.form;

                ////////////////////////////////////////////////////////////////
                // 데이터 저장
                ////////////////////////////////////////////////////////////////
                let { post, put } = api.v1.company.employment.forms;
                form = (await (!form._id ? post : put)(form))?.form;

                ////////////////////////////////////////////////////////////////
                // 리소스 저장
                ////////////////////////////////////////////////////////////////
                if (file instanceof File) file = (await api.v1.company.employment.files.post({ _form: form._id, index: "file" }, file))?.file;
                if (!!_file && _file != file?._id) await api.v1.company.employment.files.delete({ _form: form._id, _id: _file });
                _file = file?._id || null;

                pages = await Promise.all(
                    pages.map(async (page, index) => {
                        if (page instanceof File) {
                            page = (await api.v1.company.employment.files.post({ _form: form._id, index: `page-${index}` }, page))?.file;
                        }
                        return page;
                    })
                );
                _pages = pages.map(({ _id }) => _id);

                fields = await Promise.all(
                    fields.map(async ({ img, ...field }, index) => {
                        if (img instanceof File) {
                            img = (await api.v1.company.employment.files.post({ _form: form._id, index: `field-${index}` }, img))?.file;
                        }
                        field._img = img?._id || null;
                        return field;
                    })
                );

                ////////////////////////////////////////////////////////////////
                // 업데이트
                ////////////////////////////////////////////////////////////////
                form = (await put({ _id: form?._id, _file, _pages, fields }))?.form;

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", form);
            } finally {
                this.setLoading(false);
                this.shows = false;
            }
        },

        validates() {
            try {
                let hasAnEmptyTermFileField = this.form.fields.some((item) => item.type == EMPLOYMENT_FIELD_TYPES.FILE.value && !item.term);
                if (hasAnEmptyTermFileField) throw new Error("첨부파일 명칭을 입력해주세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        exit() {
            this.shows = false;
        },
    },
};
</script>
